import { tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import EAInfoBG from '@propertypal/shared/src/resources/bg/estate-agent-info-bg.jpeg';
import styled from 'styled-components';

export const Wrapper = styled.div`
  background: url(${EAInfoBG.src}) no-repeat center center fixed;
  background-size: cover;
  min-height: 100vh;
  left: 0;
  height: 100%;
  width: 100%;
`;

export const TextContainer = styled.div`
  padding: 50px 40px;
  flex-basis: 50%;

  @media (${tabletMax}) {
    padding: 20px;
  }
`;

export const SignUpHeader = styled.h2`
  font-size: 20px;
  line-height: 24px;
  max-width: 340px;
  margin-bottom: 24px;

  @media (${tabletMax}) {
    max-width: none;
  }
`;

export const PointsHeader = styled.h3`
  font-size: 18px;
`;

export const Points = styled.ul`
  padding-left: 15px;

  li {
    color: ${(props) => props.theme.textDark};
    padding: 8px 0;
    line-height: 20px;
  }
`;
